// src/context/ConfigContext.js
import React, { createContext, useEffect, useState } from "react";
import { loadConfig } from "../../../utils/configLoader";

export const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    loadConfig().then(setConfig);
  }, []);

  if (!config) return <p>Cargando configuración...</p>;

  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
};
